import React, { Component } from 'react';

class FieldLevelHelp extends Component {
    showPopover(event) {
		event.preventDefault();
        let popover = window.$(event.currentTarget).data("bs.popover");
		if (!popover) {
			window.$(event.currentTarget).popover({
				content: this.props.helpText,
				html: !!(this.props.html) || false,
				placement: "top",
				trigger: this.props.trigger || "focus",
				container: "#reactRoot .banner.section"
			});
		}
		window.$(event.currentTarget).popover("show");
	}
    render() {
        let textClassName = this.props.textClassName || "text-info";
        let iconClassName = "fa padding-x-xs " + (this.props.iconClassName || "fa-question-circle");
        return(
            <span>
            {this.props.trigger === "hover" &&
                <a href="# " onMouseOver={(e) => { this.showPopover(e); }} onClick={(e) => { e.preventDefault(); }}>
                    {!this.props.large && <small className={textClassName}><i className={iconClassName}></i>{this.props.linkText}</small>}
                    {this.props.large && <span className={textClassName}><i className={iconClassName}></i>{this.props.linkText}</span>}
                </a>
            }
            {this.props.trigger !== "hover" && 
                <a href="# " onClick={(e) => { this.showPopover(e); }}>
                    {!this.props.large && <small className={textClassName}><i className={iconClassName}></i>{this.props.linkText}</small>}
                    {this.props.large && <span className={textClassName}><i className={iconClassName}></i>{this.props.linkText}</span>}
                </a>
            }
            </span>
        )
    }

}
export default FieldLevelHelp;
